import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../../assets/js/LanguageContext';
import { localeOf } from '../../../assets/js/locale';
import Modal from '../../common/Modal';
import '../../../assets/styles/TemplateBuilder.css';

const formatDateSafe = (value, locale) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date.toLocaleDateString(locale);
};

// Aviso cuando el plan no deja crear el diagnostico: por numero de diagnosticos al mes
// o por numero de participantes. Los textos salen de lang.json con los datos que manda
// el servidor en `detalles` (el `mensaje` del servidor solo esta en español).
// Con `onEdit` (primer paso) el aviso de participantes deja volver a cambiar el Excel.
const LimitExceededModal = ({ isOpen, onClose, limitInfo, onEdit }) => {
  const { t, language } = useLanguage();
  const navigate = useNavigate();
  const locale = localeOf(language);

  const details = (limitInfo && limitInfo.detalles) ? limitInfo.detalles : (limitInfo || {});
  const isParticipants = details.maxParticipantes != null;
  const start = formatDateSafe(details.fechaInicio, locale);
  const end = formatDateSafe(details.fechaFin, locale);

  const description = isParticipants
    ? t('limit_participants_text')
      .replace('{plan}', details.plan || '')
      .replace('{max}', details.maxParticipantes)
      .replace('{count}', details.participantesSolicitados ?? '—')
    : t('limit_surveys_text')
      .replace('{plan}', details.plan || '')
      .replace('{limit}', details.limite ?? '—');

  const canEdit = isParticipants && Boolean(onEdit);

  return (
    <Modal
      open={Boolean(isOpen)}
      onOpenChange={(open) => { if (!open) (canEdit ? onEdit() : onClose()); }}
      variant="warning"
      title={t(isParticipants ? 'limit_participants_title' : 'upload_limit_title')}
      description={description}
      cancelText={canEdit ? t('limit_edit_participants') : t('upload_go_dashboard')}
      confirmText={t('upload_go_subscribe')}
      onCancel={() => (canEdit ? onEdit() : navigate('/dashboard'))}
      onConfirm={() => navigate('/subscribe')}
      size="md"
    >
      {!isParticipants && (details.encuestasCreadas != null || start || end) && (
        <ul className="tp-upload__limit">
          {details.encuestasCreadas != null && (
            <li>{t('upload_surveys_created')} {details.encuestasCreadas}</li>
          )}
          {details.limite != null && (
            <li>{t('upload_monthly_limit')} {details.limite}</li>
          )}
          {(start || end) && (
            <li>{t('upload_period')} {start || '—'} – {end || '—'}</li>
          )}
        </ul>
      )}
      <p>{t('upload_upgrade_hint')}</p>
    </Modal>
  );
};

export default LimitExceededModal;
